module.exports = __webpack_public_path__ + "static/media/MICH1.ae5f01db.png";